<div class="related-pages">
    <div class="related-pages__inner">
        <h3 class="related-pages__header">{{block.data.header}}</h3>

        <div class="related-pages__content-wrapper">
            <div *ngFor="let content of block.content; trackBy: trackByFn;" class="related-pages__content">
                <div *ngIf="content.data.image" class="related-pages__image" [ngStyle]="{backgroundImage: content.data.image ? 'url(' + content.data.image + ')' : null}"></div>
                <div class="related-pages__text">
                    <p *ngIf="content.data.text">{{content.data.text}}</p>
                    <a [href]="content.data.linkUrl" class="related-pages__link" *ngIf="content.data.linkUrl">{{content.data.linkText}}</a>
                </div>
            </div>
        </div>
    </div>
</div>
